module.exports = ".btn-outline-dark:not(:disabled):not(.disabled).active {\n  font-weight: 500 !important;\n  border: none !important; }\n"